import template from './templates/tripHotelItem.tmpl.html';
import tripEvents from './../config/events.constant';
import tripConstants from './../config/trip.constant';
import authorizedCharges from '../config/authorized-charges';

export default function TripHotelItem() {
    'ngInject';

            return {
                restrict: 'AE',
                controller: TripHotelItemController,
                controllerAs: 'tripHotelItemCtrl',
                template,
                scope: {
                    data: '=',
                    cancellation: '=tripHotelItemCancellation',
                    cancelTrip: '=tripHotelItemCancelTrip',
                    regionalSettings: '=',
                    tripDetails: '=',
                    isCancelled: '=',
                    itemCannotBeCancelled: '=',
                    getTooltip: '=',
                    showAcceptDismissForBooker: '=',
                    lastReview: '=',
                    travellers: '=',
                    status: '=',
                },
                link: function($scope, $elem, $attrs, tripHotelItemCtrl) {
                    tripHotelItemCtrl.$onInit();
                },
            };
}

export function TripHotelItemController(
    $scope,
    l10nService,
    tripUtils,
    supplierService,
    moment,
    REFUNDABLE_TYPES
) {
    'ngInject';
    const vm = this;
    const ALLOWED_STATUSES = [
        tripConstants.TRIP_STATUSES.CONFIRMED,
        tripConstants.TRIP_STATUSES.CANCELLED,
    ];

    Object.assign(vm, {
        $onInit,
        isMessageToHotelSectionVisible,
        getAuthorizedChargeTypes,
        isAuthorizedChargesVisible,
        REFUNDABLE_TYPES,
    });

    function $onInit() {
        initializeScope($scope);
    }

    function getAuthorizedChargeTypes(hotel) {
        return hotel.AuthorizedBillbackChargeTypes
            .map((type) => getAuthorizedChargeTypeLabel(type));
    }

    function getAuthorizedChargeTypeLabel(type) {
        const travellerName = getTravellerNameById(type.PassengerId);
        return `${travellerName} - ${getLabelById(type.AuthorizedBillbackChargeType)}`;
    }

    function isStatusConfirmedOrCancelled() {
        return ALLOWED_STATUSES.indexOf($scope.status) >= 0;
    }

    function getLabelById(id) {
        return _.find(authorizedCharges, {id}).label;
    }

    function isAuthorizedChargesVisible(hotel) {
        const {AuthorizedBillbackChargeTypes: charges} = hotel;
        return isStatusConfirmedOrCancelled() && charges && charges.length > 0;
    }

    function getTravellerNameById(id) {
        const {Adult, Child, Infant} = $scope.travellers;
        const travellers = [...Adult, ...Child, ...Infant];
        const traveller = _.find(travellers, {Id: id});
        return `${traveller.FirstName} ${traveller.LastName}`;
    }

    function isMessageToHotelSectionVisible(hotel) {
        return hotel
            && supplierService.isAmadeusId(hotel.Supplier)
            && !!hotel.BookingMessage
            || (hotel && supplierService.isBookingComId(hotel.Supplier) && !!hotel.BookingMessage);
    }

    function initializeScope(scope) {
        scope.l10n = l10nService;
        scope.countDays = tripUtils.countDays;
        scope.moment = moment;
        scope.getHotelDetailsUrlParams = function(hotel) {
            return {
                checkInDate: moment(hotel.CheckInDate).format(scope.regionalSettings.dateFormat),
                checkOutDate: moment(hotel.CheckOutDate).format(scope.regionalSettings.dateFormat),
                roomsQuantity: hotel.RoomQuantity,
                occupantsQuantity: hotel.OccupantsQuantity,
                cityName: hotel.City,
                centerLatitude: hotel.TripDetailsHotelSearchInfo.latitude,
                centerLongitude: hotel.TripDetailsHotelSearchInfo.longitude,
                hotelId: hotel.SearchHotelId,
                searchId: hotel.SearchCacheId,

                searchTotal: hotel.TripDetailsHotelSearchInfo.Total,
                searchMinPrice: hotel.TripDetailsHotelSearchInfo.MinimumPricePerDay,
                searchMaxPrice: hotel.TripDetailsHotelSearchInfo.MaximumPricePerDay,
                altAddress: hotel.TripDetailsHotelSearchInfo.AlternativeAddress,
            };
        };

        scope.showItemReviewStatus = scope.lastReview && scope.lastReview.needToShowTripItems() && scope.showAcceptDismissForBooker();
        scope.isItemNotIndicated = function(tripItemId) {
            return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
        };

        scope.isTripItemIdApproved = function(tripItemId) {
            return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
        };

        scope.isTripItemIdDeclined = function(tripItemId) {
            return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
        };

        scope.isNotCCUser = scope.tripDetails.ReviewTripInfo.CanBeCommented || scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        scope.isSingleReviewer = scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        scope.tripDetails.reviewModel = scope.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}};

        scope.isItemReviewed = function(hotelId) {
            return scope.tripDetails.reviewModel && scope.tripDetails.reviewModel.hotels && scope.tripDetails.reviewModel.hotels.hasOwnProperty(hotelId);
        };

        scope.applyReview = function(hotel, isAccepted) {
            scope.tripDetails.reviewModel.hotels[hotel.Id] = isAccepted;
        };

        scope.cancelTripItem = function(item) {
            const tempTripDetails = {
                Status: scope.tripDetails.Status,
                Hotels: [item],
            };
            item.isRefundable = tripUtils.isTripRefundable(tempTripDetails);
            scope.$emit(tripEvents.TRIP_CANCEL_ITEM, item);
        };
        scope.openDates = function(hotel) {
            scope.$emit(tripEvents.EDIT_HOTEL_DATES, hotel);
            const openDates = document.getElementById('datesPanel');
            openDates.classList.add('opened');
            const body = document.getElementById('body');
            body.classList.add('overlay');
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/trip-hotel-item-component.js